var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showType == 'form-builder')?_c('b-row',{staticClass:"row-container",class:_vm.selectedElementControlId == _vm.id ? 'row-container-selected' : '',style:(_vm.properties.style),attrs:{"id":"row-v1-yh7628"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.setSelected.apply(null, arguments)}}},[_vm._t("default",null,{"id":"row-v1-889mco"})],2):(_vm.showType == 'form-submitter' || _vm.showType == 'e-form')?_c('b-row',{style:(_vm.superComputeFormSubmitterValue({
      elementId: this.id,
      property: 'style',
      value: _vm.properties.style,
      defaultValue: '',
      form: this.form,
      componentPage: null
    })),attrs:{"id":"row-v1-dtfjug"}},[_vm._t("default",null,{"id":"row-v1-o5fx2t"})],2):(_vm.showType == 'form-viewer')?_c('b-row',{style:(_vm.superComputeFormSubmitterValue({
      elementId: this.id,
      property: 'style',
      value: _vm.properties.style,
      defaultValue: '',
      form: this.form,
      componentPage: null
    })),attrs:{"id":"row-v1-uar2t2"}},[_vm._t("default",null,{"id":"row-v1-1bgx2v"})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }